import { z } from 'zod';

const locatePriceSchema = z
    .number()
    .finite()
    .nonnegative()
    .refine((value) => Number(value.toFixed(4)) === value, 'Price must have at most 4 decimal places');

export const LocateInjectionReceiptSchema = z
    .object({
        optimisticOrderId: z.string().min(1).optional(),
        providerId: z.string().trim().min(1),
        symbol: z
            .string()
            .trim()
            .min(1)
            .transform((symbol) => symbol.toUpperCase()),
        quantity: z.number().int().positive(),
        pricePerShare: locatePriceSchema,
    })
    .strict();

export const InjectLocatesParamsSchema = z
    .object({
        accountId: z.string().trim().min(1),
        receipts: z.array(LocateInjectionReceiptSchema).min(1),
    })
    .strict();

export type InjectLocatesParams = z.output<typeof InjectLocatesParamsSchema>;
